import { render, staticRenderFns } from "./GatDialogToolbar.vue?vue&type=template&id=972ada10&scoped=true&"
import script from "./GatDialogToolbar.vue?vue&type=script&lang=js&"
export * from "./GatDialogToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972ada10",
  null
  
)

export default component.exports